package kangaroorewards.appsdk.core.network.base

/**
 * Thrown when the device has no internet connection.
 */
class NoConnectivityException : Exception() {
    override val message: String
        get() = "No connectivity exception"
}